import React from 'react';
import { Base } from './Base';
import { Text, TextLink } from './Text';
import { Link } from 'react-router-dom';
import { ShieldIcon } from './icons';
import { formatDate } from 'src/utils/misc';

interface EFImprovementPlanReviewDueProps {
  showDate?: string;
  plan: {
    id: string;
    name: string;
  };
  truncate?: boolean;
}

export const EFImprovementPlanReviewDue: React.FC<EFImprovementPlanReviewDueProps> = ({ showDate, plan, truncate }) => {
  return (
    <Base
      iconComponent={<ShieldIcon />}
      constentComponent={
        <Text nowrap={truncate}>
          {showDate && <Text className="sdate">{formatDate(showDate)}</Text>} Improvement plan{' '}
          <Link to={`/improvement-plans/plan/${plan.id}`}>
            <TextLink>{plan.name}</TextLink>
          </Link>{' '}
          due for review.
        </Text>
      }
    />
  );
};
